module.exports = __webpack_public_path__ + "static/img/bg_11.eb931a1b.png";